<template>
	<div>
		<!-- 回访列表 -->
		<Popup
			v-model="revisitList_popup_display"
			title="回访列表"
			confirmBtnText="新增"
			@confirmClick="handleAddRevisitClick"
		>
			<div v-loading="revisitList_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table">
					<el-table
						:data="revisitList_data"
						style="width: 100%"
					>
						<el-table-column
							prop="time"
							label="时间"
						>
						</el-table-column>
						<el-table-column
							prop="reason"
							label="回访原因"
						>
						</el-table-column>
						<el-table-column
							prop="creatName"
							label="创建人"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							width="300"
						>
							<template slot-scope="scope">
								<el-button
									@click="handleViewRevisitClick(scope.row)"
								>查看</el-button>
								<el-button
									type="danger"
									@click="handleDeleteRevisitClick(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
				
				<!-- 页码 -->
				<div class="clear_both" style="margin-top: 20px;">
					<div class="base_pager" style="float: right;">
						<el-pagination 
							layout="total, prev, pager, next, jumper" 
							next-text="下一页" 
							:total="revisitList_total"
							:current-page="revisitList_page"
							@current-change="handleRevisitListPageChange"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 页码 end-->
			</div>
		</Popup>
		<!-- 回访列表 end -->
		
		<!-- 查看回访 -->
		<Popup
			v-model="viewRevisit_popup_display"
			title="查看"
			:confirmBtnDisplay="false"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">创建人</span>
					<el-input :value="viewRevisit_data.creatName" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">渠道</span>
					<el-input :value="viewRevisit_data.channel" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">回访原因</span>
					<el-input :value="viewRevisit_data.reason" disabled></el-input>
				</div>
				<div class="base_form_row clear_both" style="margin-top: 20px;">
					<span class="b_label">裸眼视力</span>
					<div class="b_block" style="width: 245px;">
						<el-input :value="viewRevisit_data.nakedR" disabled></el-input>
					</div>
					<div class="b_block" style="width: 245px;margin-left: 20px;">
						<el-input :value="viewRevisit_data.nakedL" disabled></el-input>
					</div>
				</div>
				<div class="base_form_row clear_both" style="margin-top: 20px;">
					<span class="b_label">矫正视力</span>
					<div class="b_block" style="width: 245px;">
						<el-input :value="viewRevisit_data.correctionR" disabled></el-input>
					</div>
					<div class="b_block" style="width: 245px;margin-left: 20px;">
						<el-input :value="viewRevisit_data.correctionL" disabled></el-input>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">回访反馈</span>
					<el-input :value="viewRevisit_data.feedback" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">用户咨询</span>
					<el-input :value="viewRevisit_data.advisory" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">接电话</span>
					<el-input :value="viewRevisit_data.answer" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">陪护人</span>
					<el-input :value="viewRevisit_data.escort" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">训练频次</span>
					<el-input :value="viewRevisit_data.frequency" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">详情</span>
					<el-input :value="viewRevisit_data.detail" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">备注</span>
					<el-input :value="viewRevisit_data.remark" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看回访 end -->
		
		<!-- 新增回访 -->
		<Popup
			v-model="addRevisit_popup_display"
			title="回访"
			confirmBtnText="提交"
			@confirmClick="addRevisit"
		>
			<div v-loading="addRevisit_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>渠道</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="addRevisit_channel">
							<el-radio v-for="v in channel_list" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>回访原因</span>
					<el-input v-model="addRevisit_reason" placeholder="回访原因"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addRevisitReason_tip"><i class="b_icon"></i>请输入回访原因</template></div>
				<div class="base_form_row clear_both">
					<span class="b_label"><span style="color: #f00;">*</span>裸眼视力</span>
					<div class="b_block" style="width: 245px;">
						<el-input v-model="addRevisit_nakedR" placeholder="右眼裸眼视力"></el-input>
						<div class="base_tip"><template v-if="addRevisitNakedR_tip"><i class="b_icon"></i>右眼裸眼视力格式错误</template></div>
					</div>
					<div class="b_block" style="width: 245px;margin-left: 20px;">
						<el-input v-model="addRevisit_nakedL" placeholder="左眼裸眼视力" ></el-input>
						<div class="base_tip"><template v-if="addRevisitNakedL_tip"><i class="b_icon"></i>左眼裸眼视力格式错误</template></div>
					</div>
				</div>
				<div class="base_form_row clear_both">
					<span class="b_label"><span style="color: #f00;">*</span>矫正视力</span>
					<div class="b_block" style="width: 245px;">
						<el-input v-model="addRevisit_correctionR" placeholder="右眼矫正视力"></el-input>
						<div class="base_tip"><template v-if="addRevisitCorrectionR_tip"><i class="b_icon"></i>右眼矫正视力格式错误</template></div>
					</div>
					<div class="b_block" style="width: 245px;margin-left: 20px;">
						<el-input v-model="addRevisit_correctionL" placeholder="左眼矫正视力" ></el-input>
						<div class="base_tip"><template v-if="addRevisitCorrectionL_tip"><i class="b_icon"></i>左眼矫正视力格式错误</template></div>
					</div>
				</div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>回访反馈</span>
					<el-input v-model="addRevisit_feedback" placeholder="回访反馈"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<el-input v-model="addRevisit_advisory" placeholder="用户咨询"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addRevisitFeedback_tip"><i class="b_icon"></i>回访反馈与用户咨询请至少输入一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>接电话</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addRevisit_answer_ids">
							<el-checkbox v-for="v in answer_list" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-input v-model="addRevisit_answer_text" placeholder="其他" style="margin-top: 20px;"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addRevisitAnswer_tip"><i class="b_icon"></i>请选择接电人</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>陪护人</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addRevisit_escort_ids">
							<el-checkbox v-for="v in escort_list" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-input v-model="addRevisit_escort_text" placeholder="其他" style="margin-top: 20px;"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addRevisitEscort_tip"><i class="b_icon"></i>请选择陪护人</template></div>
				<div class="base_form_row">
					<span class="b_label">训练频次</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addRevisit_frequency">
							<el-checkbox v-for="v in frequency_list" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">详情</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addRevisit_detail_ids">
							<el-checkbox v-for="v in detail_list" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-input v-model="addRevisit_detail_text" placeholder="详情描述" style="margin-top: 20px;"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">备注</span>
					<el-input v-model="addRevisit_remark" placeholder="备注"></el-input>
				</div>
			</div>
		</Popup>
		<!-- 新增回访 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js'
	import { mapState } from 'vuex'
	import BaseMethods from '../../../../../assets/js/base.js'
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.deleteRevisit_id = '';
			this.display && (this.revisitList_popup_display = true);
		},
		data () {
			return {
				channel_list: [{
					id: '0',
					name: '呼入'
				}, {
					id: '1',
					name: '呼出'
				}, {
					id: '2',
					name: '医从'
				}, {
					id: '3',
					name: '微信'
				}, {
					id: '4',
					name: 'QQ'
				}, {
					id: '5',
					name: '后台'
				}],
				answer_list: [{
					id: '0',
					name: '父亲'
				}, {
					id: '1',
					name: '母亲'
				}],
				escort_list: [{
					id: '0',
					name: '父亲'
				}, {
					id: '1',
					name: '母亲'
				}, {
					id: '2',
					name: '祖父母'
				}],
				frequency_list: [{
					id: '0',
					name: '每日训练'
				}, {
					id: '1',
					name: '隔一天/两天训练'
				}, {
					id: '2',
					name: '一周休息一天'
				}],
				detail_list: [{
					id: '0',
					name: '遮盖处方'
				}, {
					id: '1',
					name: '距离'
				}, {
					id: '2',
					name: '时长'
				}, {
					id: '3',
					name: '加微信'
				}, {
					id: '4',
					name: '索取病历'
				}, {
					id: '5',
					name: '推送医从'
				}, {
					id: '6',
					name: '疗效'
				}, {
					id: '7',
					name: '下载方法'
				}, {
					id: '8',
					name: '操作方法'
				}, {
					id: '9',
					name: '任务量/内容'
				}, {
					id: '10',
					name: '次数扣除规则'
				}, {
					id: '11',
					name: '患者不配合建议'
				}, {
					id: '12',
					name: '什么是弱视/弱视危害/弱视治疗重要性'
				}, {
					id: '13',
					name: '大龄儿童/瓶颈期弱视治疗特点'
				}, {
					id: '14',
					name: '看不清/极限训练原理'
				}, {
					id: '15',
					name: '回答对错/得分疑虑'
				}, {
					id: '16',
					name: '提醒复查/复查时间'
				}],
				
				revisitList_popup_display: false,
				revisitList_loading: false,
				revisitList_data: [],
				revisitList_page: 1,
				revisitList_total: 0,
				
				viewRevisit_popup_display: false,
				viewRevisit_data: {},
				
				addRevisit_popup_display: false,
				addRevisit_loading: false,
				addRevisit_channel: '0',
				addRevisit_reason: '',
				addRevisit_nakedR: '',
				addRevisit_nakedL: '',
				addRevisit_correctionR: '',
				addRevisit_correctionL: '',
				addRevisit_feedback: '',
				addRevisit_advisory: '',
				addRevisit_answer_ids: [],
				addRevisit_answer_text: '',
				addRevisit_escort_ids: [],
				addRevisit_escort_text: '',
				addRevisit_frequency: [],
				addRevisit_detail_ids: [],
				addRevisit_detail_text: '',
				addRevisit_remark: '',
				addRevisitReason_tip: false,
				addRevisitNakedR_tip: false,
				addRevisitNakedL_tip: false,
				addRevisitCorrectionR_tip: false,
				addRevisitCorrectionL_tip: false,
				addRevisitFeedback_tip: false,
				addRevisitAnswer_tip: false,
				addRevisitEscort_tip: false
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/********************** @Ajax ***********************/
			// 请求回访列表数据
			getRevisitListData () {
				const that = this;
				that.revisitList_loading = true;
				var requestData = {
					id: that.uid,
					limit: '10',
					pageNum: that.revisitList_page
				};
				Api.findUserRevisits(requestData).then((res) => {
					that.revisitList_loading = false;
					if (res.data.success) {
						that.revisitList_data = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							that.revisitList_data.push({
								id: res.data.data.data[i].id,
								channel: res.data.data.data[i].channelWay || '',
								reason: res.data.data.data[i].returnVisitReason || '',
								nakedR: res.data.data.data[i].urightNeva || '',
								nakedL: res.data.data.data[i].uleftNeva || '',
								correctionR: res.data.data.data[i].urightCva || '',
								correctionL: res.data.data.data[i].uleftCva || '',
								feedback: res.data.data.data[i].returnVisitFeedback || '',
								advisory: res.data.data.data[i].userConsultation || '',
								answer: res.data.data.data[i].answerPhone || '',
								escort: res.data.data.data[i].carer || '',
								frequency: res.data.data.data[i].trainingFrequency || '',
								detail: res.data.data.data[i].describes || '',
								remark: res.data.data.data[i].remarks || '',
								time: res.data.data.data[i].createTime ? BaseMethods.formatTime(res.data.data.data[i].createTime, 'yy-mm-dd hh:mm:ss') : '',
								creatId: res.data.data.data[i].creater || '',
								creatName: res.data.data.data[i].createrName || ''
							});
						}
						that.revisitList_revisitList_total = res.data.data.totalItems;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.revisitList_loading = false;
					that.$message.error(e.message);
				});
			},
			/********************** @Events ***********************/
			// 点击查看
			handleViewRevisitClick (data) {
				const that = this;
				that.revisitList_popup_display = false;
				that.viewRevisit_data = data;
				setTimeout(() => {
					that.viewRevisit_popup_display = true;
				}, 500);
			},
			// 点击删除
			handleDeleteRevisitClick (data) {
				const that = this;
				that.deleteRevisit_id = data.id;
				that.$confirm(
					'确定要删除该回访信息?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.revisitList_loading = true;
						var requestData = {
							ids: `[${ that.deleteRevisit_id }]`
						};
						Api.deleteUserRevisit(requestData).then((res) => {
							that.revisitList_loading = false;
							if (res.data.success) {
								that.$emit('deleteRevisit', res.data.message);
							} else {
								that.$message.error(res.data.message);
							}
						}, (e) => {
							that.revisitList_loading = false;
							that.$message.error(e.message);
						});
					});
			},
			// 切换页码
			handleRevisitListPageChange (page) {
				if (this.revisitList_page != page) {
					this.revisitList_page = page;
					this.getRevisitListData();
				}
			},
			// 点击新增
			handleAddRevisitClick () {
				const that = this;
				that.revisitList_popup_display = false;
				setTimeout(() => {
					that.addRevisit_popup_display = true;
				}, 500);
			},
			// 新增回访信息
			addRevisit () {
				const that = this;
				if (!that.addRevisit_reason.trim()) {
					that.addRevisitReason_tip = true;
					return false;
				} else {
					that.addRevisitReason_tip = false;
				}
				if (!that.visionReg.test(that.addRevisit_nakedR)) {
					that.addRevisitNakedR_tip = true;
					return false;
				} else {
					that.addRevisitNakedR_tip = false;
				}
				if (!that.visionReg.test(that.addRevisit_nakedL)) {
					that.addRevisitNakedL_tip = true;
					return false;
				} else {
					that.addRevisitNakedL_tip = false;
				}
				if (!that.visionReg.test(that.addRevisit_correctionR)) {
					that.addRevisitCorrectionR_tip = true;
					return false;
				} else {
					that.addRevisitCorrectionR_tip = false;
				}
				if (!that.visionReg.test(that.addRevisit_correctionL)) {
					that.addRevisitCorrectionL_tip = true;
					return false;
				} else {
					that.addRevisitCorrectionL_tip = false;
				}
				if (!that.addRevisit_feedback.trim() && that.addRevisit_advisory.trim()) {
					that.addRevisitFeedback_tip = true;
					return false;
				} else {
					that.addRevisitFeedback_tip = false;
				}
				if (!that.addRevisit_answer_ids.length && !that.addRevisit_answer_text.trim()) {
					that.addRevisitAnswer_tip = true;
					return false;
				} else {
					that.addRevisitAnswer_tip = false;
				}
				if (!that.addRevisit_escort_ids.length && !that.addRevisit_escort_text.trim()) {
					that.addRevisitEscort_tip = true;
					return false;
				} else {
					that.addRevisitEscort_tip = false;
				}
				that.addRevisit_loading = true;
				var requestData = {
					answerPhone: that.getAddAnswer(),
					carer: that.getAddEscort(),
					channelWay: that.getAddChannel(),
					creater: that.authInfo.uid,
					describe: that.getAddDetail(),
					remarks: that.addRevisit_remark,
					returnVisitFeedback: that.addRevisit_feedback,
					returnVisitReason: that.addRevisit_reason,
					trainingFrequency: that.getAddFrequency(),
					uleftCva: that.addRevisit_correctionL,
					uleftNeva: that.addRevisit_nakedL,
					urightCva: that.addRevisit_correctionR,
					urightNeva: that.addRevisit_nakedR,
					userConsultation: that.addRevisit_advisory,
					userId: that.uid
				};
				Api.addUserRevisit(requestData).then((res) => {
					that.addRevisit_loading = false;
					if (res.data.success) {
						that.$emit('addRevisit', res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.addRevisit_loading = false;
					that.$message.error(e.message);
				});
			},
			/********************** @Function ***********************/
			// 获取新增渠道
			getAddChannel () {
				var channel = '';
				for (var i = 0;i < this.channel_list.length;i++) {
					if (this.addRevisit_channel == this.channel_list[i].id)
						channel = this.channel_list[i].name;
				}
				return channel;
			},
			// 获取添加接电话人
			getAddAnswer () {
				var answer_phone = '';
				for (var w = 0;w < this.addRevisit_answer_ids.length;w++) {
					for (var i = 0;i < this.answer_list.length;i++) {
						if (this.addRevisit_answer_ids[w] == this.answer_list[i].id)
							answer_phone += this.answer_list[i].name + '；';
					}
				}
				this.addRevisit_answer_text.trim() && (answer_phone += this.addRevisit_answer_text + '；');
				return answer_phone;
			},
			// 获取添加陪护人
			getAddEscort () {
				var escort_phone = '';
				for (var w = 0;w < this.addRevisit_escort_ids.length;w++) {
					for (var i = 0;i < this.escort_list.length;i++) {
						if (this.addRevisit_escort_ids[w] == this.escort_list[i].id)
							escort_phone += this.escort_list[i].name + '；';
					}
				}
				this.addRevisit_escort_text.trim() && (escort_phone += this.addRevisit_escort_text + '；');
				return escort_phone;
			},
			// 获取添加训练频次
			getAddFrequency () {
				var frequency = '';
				for (var w = 0;w < this.addRevisit_frequency.length;w++) {
					for (var i = 0;i < this.frequency_list.length;i++) {
						if (this.addRevisit_frequency[w] == this.frequency_list[i].id)
							frequency += this.frequency_list[i].name + '；';
					}
				}
				return frequency;
			},
			// 获取添加详情
			getAddDetail () {
				var detail = '';
				for (var w = 0;w < this.addRevisit_detail_ids.length;w++) {
					for (var i = 0;i < this.detail_list.length;i++) {
						if (this.addRevisit_detail_ids[w] == this.detail_list[i].id)
							detail += this.detail_list[i].name + '；';
					}
				}
				this.addRevisit_detail_text.trim() && (detail += this.addRevisit_detail_text + '；');
				return detail;
			}
		},
		watch: {
			display (newValue) {
				this.revisitList_popup_display = newValue;
			},
			revisitList_popup_display (newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.revisitList_loading = false;
					this.revisitList_data = [];
					this.revisitList_page = 1;
					this.revisitList_total = 0;
					this.getRevisitListData();
				}
			},
			viewRevisit_popup_display(newVal) {
				!newVal && (this.viewRevisit_data = {});
			},
			addRevisit_popup_display(newVal) {
				if (!newVal) {
					this.addRevisit_loading = false;
					this.addRevisit_channel = '0';
					this.addRevisit_reason = '';
					this.addRevisit_nakedR = '';
					this.addRevisit_nakedL = '';
					this.addRevisit_correctionR = '';
					this.addRevisit_correctionL = '';
					this.addRevisit_feedback = '';
					this.addRevisit_advisory = '';
					this.addRevisit_answer_ids = [];
					this.addRevisit_answer_text = '';
					this.addRevisit_escort_ids = [];
					this.addRevisit_escort_text = '';
					this.addRevisit_frequency = [];
					this.addRevisit_detail_ids = [];
					this.addRevisit_detail_text = '';
					this.addRevisit_remark = '';
					this.addRevisitReason_tip = false;
					this.addRevisitNakedR_tip = false;
					this.addRevisitNakedL_tip = false;
					this.addRevisitCorrectionR_tip = false;
					this.addRevisitCorrectionL_tip = false;
					this.addRevisitFeedback_tip = false;
					this.addRevisitAnswer_tip = false;
					this.addRevisitEscort_tip = false;
				}
			}
		}
	}
</script>

<style>
</style>
